import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

import LocationCityIcon from '@mui/icons-material/LocationCity'
import StoreIcon from '@mui/icons-material/Store'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import HouseIcon from '@mui/icons-material/House'
import ApartmentIcon from '@mui/icons-material/Apartment'

const ICON_BY_HASH = [LibraryBooksIcon, StoreIcon, ApartmentIcon, HouseIcon, LocationCityIcon]

const PALETTE = [
    '#1976d2',
    '#388e3c',
    '#7b1fa2',
    '#c2185b',
    '#f57c00',
    '#0097a7',
    '#5d4037',
    '#455a64',
    '#d32f2f',
    '#512da8'
]

const hash = (str = '') => {
    let h = 0
    for (let i = 0; i < str.length; i++) {
        h = str.charCodeAt(i) + ((h << 5) - h)
    }
    return Math.abs(h)
}

export const colorFromString = (str = '') => PALETTE[hash(str) % PALETTE.length]

export const iconFromString = (str = '') => ICON_BY_HASH[hash(str) % ICON_BY_HASH.length]

export const isExpired = (expirationDate) =>
    expirationDate ? dayjs().diff(dayjs(expirationDate), 'day') > 0 : false

export const daysToExpiration = (expirationDate) =>
    expirationDate ? dayjs(expirationDate).diff(dayjs(), 'day') : null

export const getStoreStatus = (store) => {
    if (!store) return { key: 'unknown', label: 'Unknown', color: 'default' }
    if (isExpired(store.expirationDate)) return { key: 'expired', label: 'Expired', color: 'error' }
    const days = daysToExpiration(store.expirationDate)
    if (days != null && days <= 30)
        return { key: 'expiring', label: 'Expiring soon', color: 'warning' }
    return { key: 'active', label: 'Active', color: 'success' }
}

export const getOccupancyPercent = (store) => {
    const cap = Number(store?.capacity) || 0
    const cur = Number(store?.currentOccupancy) || 0
    if (cap <= 0) return 0
    return Math.min(100, Math.round((cur / cap) * 100))
}

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, h) => {
    const v = `${h.toString().padStart(2, '0')}:00`
    return { value: v, label: v }
})

const getStaticOffset = (tz) => {
    try {
        return dayjs.tz('2025-01-01T00:00:00Z', tz).format('Z')
    } catch {
        return '+00:00'
    }
}

const buildTimezoneOptions = () => {
    if (typeof Intl?.supportedValuesOf !== 'function') return []
    return Intl.supportedValuesOf('timeZone')
        .map((tz) => {
            const offset = getStaticOffset(tz)
            const numericOffset = parseFloat(offset.replace(':', '.'))
            return { value: tz, label: `(GMT${offset}) ${tz}`, numericOffset }
        })
        .sort((a, b) => a.numericOffset - b.numericOffset)
}

export const TIMEZONE_OPTIONS = buildTimezoneOptions()
